import { useMutation } from "@tanstack/react-query";
import { apiClient } from "~/lib/client";
import { handleError, handleResponse } from "~/utils/response";
import { BookingFormData, RescheduleAppointmentSchemaData } from "../../schemas";
import { appointmentKeys } from "../queries/keys";

import { toast } from "sonner";
import { CreateAppointmentResponse, CreateAppointmentResponseData, UpdateRescheduleAppointmentResponse, UpdateRescheduleAppointmentResponseData } from "../types";
import { getQueryClient } from "~/providers/query.provider";

export const useCreateAppointmentBookingMutation = () => {
  const queryClient = getQueryClient();

  return useMutation<CreateAppointmentResponse, unknown, BookingFormData>({
    mutationFn: async (variables: BookingFormData) => {
      try {
        const response = await apiClient("/appointments", {
          method: "POST",
          body: JSON.stringify(variables),
        });

        return await handleResponse<CreateAppointmentResponseData>(response);
      } catch (error) {
        return handleError(error);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all }
      );
    },
    onError: () => {
      toast.error("Failed to book appointment");
    },
  });
};

export const useRescheduleAppointmentMutation = (id: string) => {
  const queryClient = getQueryClient();

  return useMutation<
    UpdateRescheduleAppointmentResponse,
    unknown,
    RescheduleAppointmentSchemaData
  >({
    mutationFn: async (variables: RescheduleAppointmentSchemaData) => {
      try {
        const response = await apiClient(`/appointments/${id}`, {
          method: "PUT",
          body: JSON.stringify(variables),
        });

        return await handleResponse<UpdateRescheduleAppointmentResponseData>(response);
      } catch (error) {
        return handleError(error);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all }
      );
    },
    onError: () => {
      toast.error("Failed to reschedule appointment");
    },
  });
};


